var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7502 15.7502L12.131 12.131M12.131 12.131C12.7501 11.5119 13.2412 10.777 13.5762 9.96813C13.9112 9.15927 14.0837 8.29234 14.0837 7.41684C14.0837 6.54134 13.9112 5.67441 13.5762 4.86555C13.2412 4.05669 12.7501 3.32174 12.131 2.70267C11.5119 2.0836 10.777 1.59252 9.96813 1.25748C9.15927 0.922443 8.29234 0.75 7.41684 0.75C6.54134 0.75 5.67441 0.922443 4.86555 1.25748C4.05669 1.59252 3.32174 2.0836 2.70267 2.70267C1.4524 3.95295 0.75 5.64868 0.75 7.41684C0.75 9.18499 1.4524 10.8807 2.70267 12.131C3.95295 13.3813 5.64868 14.0837 7.41684 14.0837C9.18499 14.0837 10.8807 13.3813 12.131 12.131Z",
    stroke: "#4E4E4E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomSearch);
export default __webpack_public_path__ + "static/media/custom-search.e468cadcfb68d2ecfc37c84481f60aaf.svg";
export { ForwardRef as ReactComponent };